import React from "react";

import Script from "dangerous-html/react";

const TestimonialsSection: React.FC = () => (
  <section className="testimonials-wrapper">
    <div className="testimonials-container">
      <div className="testimonials-header">
        <h2 className="section-title">Client Feedback</h2>
        <p className="section-subtitle">
          Endorsements and experiences from colleagues and business partners.
        </p>
      </div>
      <div className="testimonials-grid">
        <div className="testimonials-card">
          <div className="testimonials-card-quote-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2zM5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"
              ></path>
            </svg>
          </div>
          <p className="testimonials-card-text">
            Anuj provided architecture that brought reliability and efficiency
            to our retail operations. With microservices, we consistently
            achieved 99.98% uptime in 3000+ stores.
          </p>
          <div className="testimonials-card-author">
            <div className="testimonials-card-author-name">
              <span>Abhishek R.</span>
            </div>
            <div className="testimonials-card-author-title">
              <span>
                {" "}
                Senior Manager, Alshaya
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
            </div>
          </div>
        </div>
        <div className="testimonials-card">
          <div className="testimonials-card-quote-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2zM5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"
              ></path>
            </svg>
          </div>
          <p className="testimonials-card-text">
            Anuj’s knowledge of AWS Bedrock and FastAPI supported rapid roll-out
            of our Generative AI analytics, cutting delivery times by 70%.
          </p>
          <div className="testimonials-card-author">
            <div className="testimonials-card-author-name">
              <span>Neil K.</span>
            </div>
            <div className="testimonials-card-author-title">
              <span>
                {" "}
                Product Manager, ETS
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
            </div>
          </div>
        </div>
        <div className="testimonials-card">
          <div className="testimonials-card-quote-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2zM5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"
              ></path>
            </svg>
          </div>
          <p className="testimonials-card-text">
            Implementation of OAuth2 and Cognito by Anuj has minimized the
            security incidents and helps us in achieving compliance.
          </p>
          <div className="testimonials-card-author">
            <div className="testimonials-card-author-name">
              <span>Rajesh Kumar</span>
            </div>
            <div className="testimonials-card-author-title">
              <span>
                {" "}
                Senior Architect, Success Numbers
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
            </div>
          </div>
        </div>
        <div className="testimonials-card">
          <div className="testimonials-card-quote-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2zM5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"
              ></path>
            </svg>
          </div>
          <p className="testimonials-card-text">
            I have worked with Anuj Tiwari for about eight years. He is a very
            enthusiastic and keen person. His deployments improved with new
            CI/CD pipelines in Jenkins/GitLab has helped in lesser lead time and
            reliable releases.
          </p>
          <div className="testimonials-card-author">
            <div className="testimonials-card-author-name">
              <span>Raghavendra K.</span>
            </div>
            <div className="testimonials-card-author-title">
              <span>
                {" "}
                Project Manager, A Non-profit Organization
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
            </div>
          </div>
        </div>
        <div className="testimonials-card">
          <div className="testimonials-card-quote-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2zM5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"
              ></path>
            </svg>
          </div>
          <p className="testimonials-card-text">
            Amongst the many tasks, I commend Anuj's contribution to our project
            in adoption of AWS CDK and Terraform. This has helped us achieve
            standardized and scalable environments.
          </p>
          <div className="testimonials-card-author">
            <div className="testimonials-card-author-name">
              <span>Ann Johnston</span>
            </div>
            <div className="testimonials-card-author-title">
              <span>
                {" "}
                Manager, ETS
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
            </div>
          </div>
        </div>
        <div className="testimonials-card">
          <div className="testimonials-card-quote-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2zM5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1a6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"
              ></path>
            </svg>
          </div>
          <p className="testimonials-card-text">
            Flexible API service mesh (REST, gRPC, WebSockets, GraphQL) from
            Anuj enabled us to support multiple business workflows with ease.
          </p>
          <div className="testimonials-card-author">
            <div className="testimonials-card-author-name">
              <span>Mukesh Khandelwal</span>
            </div>
            <div className="testimonials-card-author-title">
              <span>
                {" "}
                Tech Lead, Iris Software Technologies
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
